exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-landing-page-js": () => import("./../../../src/templates/landing-page.js" /* webpackChunkName: "component---src-templates-landing-page-js" */),
  "component---src-templates-opco-homepage-js": () => import("./../../../src/templates/opco-homepage.js" /* webpackChunkName: "component---src-templates-opco-homepage-js" */),
  "component---src-templates-subpage-js": () => import("./../../../src/templates/subpage.js" /* webpackChunkName: "component---src-templates-subpage-js" */)
}

